import React, { useState, useCallback, useEffect } from 'react';
import { usePrevious } from "../hooks";
import { Popover, ChoiceList, Button, LegacyStack } from '@shopify/polaris';

export function ChoiceListPickerCustom(props) {

    const [active, setActive] = useState(false);
    const [selected, setSelected] = useState(props.selected);

    const prevValue = usePrevious(selected);

    const handlePopoverOpen = useCallback(
        () => setActive(true),
        [],
    );

    const handlePopoverClose = useCallback(
        () => setActive(false),
        [],
    );

    const handlePopoverActive = useCallback(
        () => {
            if (active) {
                handlePopoverClose();
            }
            else {
                handlePopoverOpen();
            }
        },
        // eslint-disable-next-line
        [active],
    );

    const handleChange = useCallback(
        (newValue, active) => {
            setSelected(newValue);
            setActive(active);
            props.handleChange(props.fieldName, newValue !== '' ? newValue[0] : '');
        },
        // eslint-disable-next-line
        [],
    );

    useEffect(() => {
        if (prevValue !== props.selected) {
            setSelected(props.selected);
        }
    }, [prevValue, props.selected]);

    const activator = (
        <Button disclosure="down" onClick={handlePopoverActive}>{props.title}</Button>
    );

    return (
        <Popover
            active={active}
            activator={activator}
            onClose={handlePopoverClose}
            preferredAlignment={'left'}
        >
            <Popover.Section>
                <LegacyStack vertical={true} spacing="tight">
                    <LegacyStack.Item>
                        <ChoiceList
                            choices={props.choices}
                            selected={selected}
                            onChange={(newValue) => handleChange(newValue, true)}
                        />
                    </LegacyStack.Item>
                    <LegacyStack.Item>
                        <Button variant="plain" disabled={selected === '' || (selected.length && selected[0] === '')} onClick={() => handleChange('', false)}>Clear</Button>
                    </LegacyStack.Item>
                </LegacyStack>
            </Popover.Section>
        </Popover>
    );
}